import { render, staticRenderFns } from "./GoodsCreate.vue?vue&type=template&id=f96f7866&scoped=true"
import script from "./GoodsCreate.vue?vue&type=script&lang=js"
export * from "./GoodsCreate.vue?vue&type=script&lang=js"
import style0 from "./GoodsCreate.vue?vue&type=style&index=0&id=f96f7866&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96f7866",
  null
  
)

export default component.exports